import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useData } from '../../context/DataContext';
import { notificationsAPI } from '../../services/api';
import Modal from '../../components/Modal';

const AdminNotifications = () => {
  const { t } = useTranslation();
  const { students, instructors } = useData();
  const [items, setItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [form, setForm] = useState({ recipientId: '', title: '', message: '', type: 'system', channels: ['portal'] });

  const recipients = [...students, ...instructors];

  const loadItems = async () => {
    const response = await notificationsAPI.getAll();
    setItems(response.notifications || []);
  };

  useEffect(() => {
    loadItems();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    await notificationsAPI.create(form);
    setForm({ recipientId: '', title: '', message: '', type: 'system', channels: ['portal'] });
    setShowModal(false);
    await loadItems();
  };

  const handleProcessQueue = async () => {
    setProcessing(true);
    try {
      const result = await notificationsAPI.processQueue(50);
      alert(`Queue verwerkt: ${result.processedCount}`);
      await loadItems();
    } catch (error) {
      alert(error.message || 'Queue verwerken mislukt');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="users-page">
      <div className="page-header">
        <h1>{t('notification.title')}</h1>
        <div className="form-actions">
          <button className="btn-secondary" onClick={handleProcessQueue} disabled={processing}>
            {processing ? 'Processing...' : 'Process WhatsApp Queue'}
          </button>
          <button className="btn-primary" onClick={() => setShowModal(true)}>{t('common.add')}</button>
        </div>
      </div>

      <div className="user-grid">
        {items.map((item) => (
          <div key={item.id} className="user-card" style={{ display: 'block' }}>
            <h3>{item.title}</h3>
            <p>{item.message}</p>
            <small>{item.recipient?.name} | {item.type} | {item.whatsappStatus}</small>
          </div>
        ))}
      </div>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title={t('common.add')}>
        <form onSubmit={handleCreate} className="add-form">
          <select
            className="form-input"
            value={form.recipientId}
            onChange={(e) => setForm((prev) => ({ ...prev, recipientId: e.target.value }))}
            required
          >
            <option value="">{t('common.select')}</option>
            {recipients.map((r) => (
              <option key={r.id} value={r.id}>{r.name}</option>
            ))}
          </select>
          <input
            className="form-input"
            value={form.title}
            onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
            placeholder={t('common.name')}
            required
          />
          <textarea
            className="form-textarea"
            value={form.message}
            onChange={(e) => setForm((prev) => ({ ...prev, message: e.target.value }))}
            placeholder={t('course.description')}
            required
          />
          <div className="form-row">
            <label>
              <input
                type="checkbox"
                checked={form.channels.includes('portal')}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  channels: e.target.checked
                    ? Array.from(new Set([...prev.channels, 'portal']))
                    : prev.channels.filter((c) => c !== 'portal')
                }))}
              />
              Portal
            </label>
            <label>
              <input
                type="checkbox"
                checked={form.channels.includes('whatsapp')}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  channels: e.target.checked
                    ? Array.from(new Set([...prev.channels, 'whatsapp']))
                    : prev.channels.filter((c) => c !== 'whatsapp')
                }))}
              />
              WhatsApp
            </label>
          </div>
          <div className="form-actions">
            <button className="btn-primary" type="submit">{t('common.save')}</button>
            <button className="btn-secondary" type="button" onClick={() => setShowModal(false)}>{t('common.cancel')}</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default AdminNotifications;
